// QueriesPausedBanner — global "reads are paused" strip driven by react-query's
// onlineManager, the signal that ACTUALLY pauses queries (networkMode 'online').
//
// Deliberately NOT navigator.onLine: the offline write-queue badge tracks that,
// and the two can disagree — the idle-wake audit's 6.1 state (a device whose
// navigator.onLine lies false on VPN/virtual NICs, or a missed 'online' event)
// pauses every query with zero errors and nothing on the wire, which renders
// as stale/empty pages with no explanation. While this banner shows, "No X
// yet" claims are suppressed page-side by QueryStateGate; this is the global
// WHY. The 15s reconciler in main.tsx un-wedges the flag when the OS says
// online, so a lying-flag state self-heals ≤15s and this strip disappears.

import { useSyncExternalStore } from 'react'
import { onlineManager } from '@tanstack/react-query'
import { WifiOff } from 'lucide-react'

function subscribe(cb: () => void) {
  return onlineManager.subscribe(cb)
}
function getSnapshot() {
  return onlineManager.isOnline()
}

export default function QueriesPausedBanner() {
  const online = useSyncExternalStore(subscribe, getSnapshot)
  if (online) return null
  return (
    <div
      role="status"
      className="bg-amber-800/95 text-amber-50 border-b border-amber-900 px-3 py-1.5 flex items-center gap-2 text-xs print:hidden">
      <WifiOff size={14} className="shrink-0" />
      <span className="truncate">
        Connection lost — showing saved data; updates will load when it returns
      </span>
    </div>
  )
}
